<template> 
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <div>
          <!--<v-tabs v-model="tab">
            <v-tab>Server Data</v-tab>
            <v-tab v-if="statusOffline">Local Data</v-tab>
            <v-spacer/>
            <v-btn icon color="green" dark :to="{name:'tes/survey/respon/form', query:{jilid_id:$route.query.jilid_id}}"><v-icon>add</v-icon></v-btn>                      
            <v-menu bottom left>
              <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
              <v-list>
                <v-list-tile v-bind:to="{path:'/tes/survey/respon/rekap', query:$route.query}">
                  <v-list-tile-title>Rekap</v-list-tile-title>
                </v-list-tile>                       
              </v-list>
            </v-menu> 
          </v-tabs>-->
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-toolbar flat>      
                  <v-text-field flat dense filled
                    v-model="term"                    
                    label="Search"
                    single-line
                    hide-details        
                    @input="search"
                    style="max-width:200px"
                  ></v-text-field>                             
                  <v-btn icon color="blue-grey" dark :loading="loading" @click="readItems"><v-icon>find_replace</v-icon></v-btn>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 
                  <v-spacer/>
                  <v-btn color="success" @click="export2excel()" dark>
                    <v-icon left>save</v-icon> export .xls
                  </v-btn>   
                </v-toolbar>
                <v-card-text>      
                  <v-container fluid grid-list-lg class="pa-0 ma-0">
                    <v-layout row wrap>
                      <v-flex xs12 md12 class="v-table__overflow" style="position:relative; overflow-x: auto;" id="export">
                        <table class="tb-normal">
                          <thead>
                            <tr>
                              <th rowspan="2">No</th>  
                              <th rowspan="2">ID</th>                                                
                              <th rowspan="2">Date</th>                              
                              <th rowspan="2">Code</th>
                              <th rowspan="2">Name</th>
                              <th rowspan="2">Tingkat</th>
                              <th rowspan="2">Phone</th>
                              <th rowspan="2">Nama Ayah</th>
                              <th rowspan="2">Nama Ibu</th>                              
                              <th :colspan="items[0] && items[0].responDtls ? items[0].responDtls.length : 0">Pertanyaan</th>
                              <th rowspan="2">Surveyor</th>
                              <th rowspan="2" style="min-width:130px">Created at</th>                              
                            </tr>
                            <tr v-if="items[0] && items[0].responDtls">
                              <th v-for="(item,i) in items[0].responDtls" :key="i">
                                {{item.no}}                    
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(respon, i ) in items">
                              <tr :key="i">
                                <td valign="top">{{i+1}}</td>
                                <td valign="top">{{ respon.responden.id}}</td>                                
                                <td valign="top" style="min-width:90px">{{$moment(respon.created_at*1000).format('DD-MM-YYYY')}}</td>                                
                                <td valign="top">{{respon.code}}</td>
                                <td valign="top">{{ respon.responden.nama }}({{respon.responden.gender == 1 ? 'L':'P'}})</td>
                                <td valign="top" v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===respon.responden.jurusan_id) ? tingkats.find(x=>x.id===respon.responden.jurusan_id).description : tingkats.find(x=>x.id===respon.responden.tingkat_id).description}}</td>                  
                                <td valign="top">{{ respon.responden.telepon }}</td>
                                <td valign="top">{{ respon.responden.ayah_nama }}</td>
                                <td valign="top">{{ respon.responden.ibu_nama }}</td>
                                <template v-if="Array.isArray(respon.responDtls) && respon.responDtls.length > 0">
                                  <template v-for="(item, j) in respon.responDtls">
                                    <td :key="j" valign="top">
                                      <!--<template v-if="fm.type===1">
                                        <span v-if="item.type === 1">{{item.answer_id}}</span>
                                        <span v-if="item.type === 2">                          
                                          <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                            {{ans}},
                                          </span>
                                        </span>                            
                                      </template>
                                      <template v-if="fm.type===2">
                                        <span v-if="item.type === 1">{{item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).key : ''}}</span>
                                        <span v-if="item.type === 2">                          
                                          <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                            {{item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).key : ''}},
                                          </span>
                                        </span>
                                      </template>-->
                                      <template>
                                        <span v-if="item.type === 1">{{item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).value : ''}}</span>
                                        <span v-if="item.type === 2">                          
                                          <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                            {{item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).value : ''}},
                                          </span>
                                        </span>
                                      </template>
                                      <!--<template v-if="fm.type===2">
                                        <span v-if="item.type === 1">{{item.answer_value}}</span>
                                        <span v-if="item.type === 2">                          
                                          <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                            {{ans}},
                                          </span>
                                        </span>
                                      </template>-->
                                      <span v-if="item.type === 3">
                                        <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                          {{ans}},
                                        </span>
                                      </span>  
                                    </td>
                                  </template>
                                </template>
                                <template v-else-if="items[0] && items[0].responDtls">
                                  <td :colspan="items[0].responDtls.length"></td>
                                </template>  
                                <td valign="top">{{respon.createdby?respon.createdby.username:null}}</td>
                                <td valign="top">{{$moment(respon.created_at*1000).format('DD-MM-YYYY HH:mm')}}</td>                                
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </v-flex>                              
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card> 
            </v-tab-item>      
          </v-tabs-items>
        </div>  
      </v-container>
    </div>
  </v-slide-y-transition>      
</template>

<script>
import { debounce } from 'lodash'
import model from '@/apps/admin/models/master/Respon'
import Table2Excel from 'table2excel.js';  

export default {  
  data () {
    return {
      tab : 0,
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Date', value:'date'},
        {text:'Code', value:'code'},
        {text:'Name', value:'responden.nama'},
        {text:'Tingkat', value:'responden.tingkat_id'},
        {text:'Phone', value:'responden.telepon'},
        {text:'Nama Ayah', value:'responden.ayah_nama'},   
        {text:'Nama Ibu', value:'responden.ibu_nama'},   
        {text:'Surveyor', value:'createdby.username'},     
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,    
      toggle_tingkat : [],
      toggle_gender : [], 
      tingkats :[], 
    }
  },
  computed:{
    status(){
      return {0:'active',1:'inactive'};      
    }, 
    statusOffline(){
      return false;
    }   
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    },
    toggle_tingkat(newArr){
      let tingkat = [], jurusan = [];
      newArr.forEach(ar=>{
        if(ar <= 3){tingkat.push(ar);} 
        else if(ar === 7){tingkat.push(ar);}
        else{jurusan.push(ar);}
      });                
      this.readItems(this.page, this.toggle_gender, tingkat, jurusan);        
    },
    toggle_gender(newArr){ 
      let tingkat = [], jurusan = [];
      this.toggle_tingkat.forEach(ar=>{
        if(ar <= 3){tingkat.push(ar);} 
        else if(ar === 7){tingkat.push(ar);}
        else{jurusan.push(ar);}
      });                
      this.readItems(this.page, newArr, tingkat, jurusan);        
    },
  },  
  created () {
    this.readItems()
  },
  mounted(){
    this.tab = this.statusOffline ? 1 : 0;
    model.tingkats().then(data=>{this.tingkats = data});
      
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0, gender='', tingkat_id='', jurusan_id='') {
      this.loading = true; this.items = [];
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        jilid_id: this.$route.query.jilid_id,
        sort:sortby,
        gender: gender,
        tingkat_id: tingkat_id,
        jurusan_id: jurusan_id,            
        expand:'createdby,responden,responDtls',
        nopagination:true
      }

      model.index(params)
        .then(response => {
          this.items = response.data;
          //this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    

    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
    },

    export2excel(){
        if(this.items.length !== 0){
            var filename = 'Angket.';            
            filename    += this.$moment().format('DDMMYY');
            new Table2Excel('#export table').export(filename);
        } else {
            window.getApp.$emit('showSnackbar', {
                show : true,
                text : 'No Data Result',
                color: 'orange'
            });
        }
    },
  },  
}
</script>
<style>
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>